import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import type { CommonStoreState } from '../../store'
import UAccordionHeader from './UAccordionHeader'
import { Checkbox } from '@panwds/react-form'
import type { BannerProps } from './UAccordion'
import { Banner, Body, Bold, Tag } from '@panwds/react-ui'
import UScreenHeader from './UScreenHeader'
import AppContext from '../../../common/context/AppContext'
import { useFormContext } from 'react-hook-form'
import SubscriptionService from '../../services/SubscriptionService'
import { APP_ID_AI_OPS, APP_ID_IOT, APP_ID_LOGGING_SERVICE } from '../common/GlobalConstants'
import { APP_ID_SAASINLINE } from '../../constants'
import ScreenLoader from '../common/ScreenLoader'
import _ from 'lodash'

export interface UDeploymentProfilesProps {
  state: CommonStoreState;
  title: string;
  subtitle?: string;
  deploymentProfiles?: any[];
  updateTitle: (title: any) => void;
  setAccordionOpen: (isOpen: boolean) => void;
  setDisable: (disable: boolean) => void;
}
export interface deploymentProfile {
  deploymentProfileId: number
  profileName: string
  dAuthCode: string
  subscriptions: Subscription[]
  type: string
  isProfileCompatible: boolean;
  isAssociated: boolean;
}
export interface Subscription {
  app_id: string
  package_version?: number
}
export async function getProfilesInformation(tsg_id: string, support_account_id: string): Promise<deploymentProfile[]> {

  const { data } = await SubscriptionService.deploymentProfiles.getForCSP(tsg_id, support_account_id).catch((err) => {
    return { data: [] }
  })
  return data
}
const usePrevious = (value: any, initialValue: any) => {
  const ref = useRef(initialValue)
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}
const useEffectDebugger = (effectHook: React.EffectCallback, dependencies: React.DependencyList | undefined, dependencyNames = []) => {
  const previousDeps = usePrevious(dependencies, [])

  const changedDeps = dependencies?.reduce((accum, dependency, index) => {
    if (dependency !== previousDeps[index]) {
      const keyName = dependencyNames[index] || index
      return {
        ...accum,
        [keyName]: {
          before: previousDeps[index],
          after: dependency
        }
      }
    }

    return accum
  }, {})

  if (Object.keys(changedDeps).length) {
    // console.log('[use-effect-debugger] ', changedDeps)
  }

  useEffect(effectHook, dependencies)
}
const UDeploymentProfiles = (props: UDeploymentProfilesProps) => {
  const { getAppName } = useContext(AppContext)
  const { setValue, setError, clearErrors, watch, getValues } = useFormContext()
  const { state, title, subtitle, updateTitle, setDisable, setAccordionOpen } = props
  const { apps, licenses, instances, tsg, loadingTsg, manifest, globalTsgId, activationData, supportAccountId } = state
  const [checkedList, setCheckedList] = useState<any[]>([])
  const [profiles, setProfiles] = useState<{ availableProfiles: deploymentProfile[], notAvailableProfiles: deploymentProfile[] }>({ availableProfiles: [], notAvailableProfiles: [] })
  const [availableProfiles, setAvailableProfiles] = useState<deploymentProfile[]>([])
  const [notAvailableProfiles, setNotAvailableProfiles] = useState<deploymentProfile[]>([])
  const [profileLoading, setProfileLoading] = useState<boolean>(false)
  const currentCSP = useRef<{ supportAccountId: string }>({ supportAccountId: '' })
  currentCSP.current.supportAccountId = state.supportAccountId

  useEffect(() => {
    //console.log(`UPDATING IT ${supportAccountId} ${tsg?.id} ${loadingTsg} ${globalTsgId}`, instances)
    const fetchDeploymentProfile = async (tsg_id: string, support_account_id: string, instances: any[]) => {
      try {
        const response = await getProfilesInformation(tsg_id, support_account_id)
        // const response = [
        //   {
        //     'deploymentProfileId': '30050',
        //     'profileName': 'np-dp-iot-1',
        //     'dAuthCode': 'D6298321',
        //     'type': 'VM',
        //     'subscriptions': [
        //       {
        //         'subscription': 'ENIOTPDRDL',
        //         'app_id': 'zingbox',
        //         'status': 1,
        //         'package_version': 2
        //       }
        //     ],
        //     'isAssociated': true,
        //     'isProfileCompatible': true
        //   },
        //   {
        //     'deploymentProfileId': '30053',
        //     'profileName': 'IOTFixed1501',
        //     'dAuthCode': 'D7981331',
        //     'type': 'VM',
        //     'subscriptions': [
        //       {
        //         'subscription': 'ENIOTDRDL',
        //         'app_id': 'zingbox',
        //         'status': 1,
        //         'package_version': 2
        //       }
        //     ],
        //     'isAssociated': false,
        //     'isProfileCompatible': true
        //   },
        //   {
        //     'deploymentProfileId': '30056',
        //     'profileName': 'IOTFlexible1501',
        //     'dAuthCode': 'D2645662',
        //     'type': 'VM',
        //     'subscriptions': [
        //       {
        //         'subscription': 'ENIOTPDRDL',
        //         'app_id': 'zingbox',
        //         'status': 0,
        //         'package_version': 2
        //       }
        //     ],
        //     'isAssociated': false,
        //     'isProfileCompatible': true
        //   },
        //   {
        //     'deploymentProfileId': '30060',
        //     'profileName': 'np-dp-iot-2',
        //     'dAuthCode': 'D5883333',
        //     'type': 'VM',
        //     'subscriptions': [
        //       {
        //         'subscription': 'ENIOTPDRDL',
        //         'app_id': 'zingbox',
        //         'status': 1,
        //         'package_version': 2
        //       }
        //     ],
        //     'isAssociated': false,
        //     'isProfileCompatible': true
        //   },
        //   {
        //     'deploymentProfileId': '30063',
        //     'profileName': 'np-dp-iot-demo-1',
        //     'dAuthCode': 'D8891705',
        //     'type': 'VM',
        //     'subscriptions': [
        //       {
        //         'subscription': 'ENIOTPDRDL',
        //         'app_id': 'zingbox',
        //         'status': 1,
        //         'package_version': 2
        //       }
        //     ],
        //     'isAssociated': false,
        //     'isProfileCompatible': true
        //   }
        // ]
        //console.log('data', response)
        if (currentCSP.current.supportAccountId === support_account_id) {
          const finalList = response?.filter((profile) => profile.isAssociated && profile.isProfileCompatible).map((p) => p.dAuthCode)
          const avaiableProfiles = response?.filter((profile) => profile.isProfileCompatible)
          const notAvaiableProfiles = response?.filter((profile) => !profile.isProfileCompatible)
          setCheckedList(finalList)
          updateTitle(getTitle(avaiableProfiles.filter((p) => finalList.includes(p.dAuthCode))))
          setValue('deployment_profiles', avaiableProfiles.filter((p) => finalList.includes(p.dAuthCode)).map((s) => _.omit(s, ['isAssociated', 'isProfileCompatible'])))
          setAvailableProfiles(avaiableProfiles as any)
          setNotAvailableProfiles(notAvaiableProfiles as any)
          setProfileLoading(false)
          setAccordionOpen(true)
          updateTitle(`Deployment Profile(s): ${finalList?.length || 0} Selected`)
        }
        else {
          //console.log('old support id')
        }
      }
      catch (error) {
        setProfileLoading(false)
      }
    }
    if (supportAccountId && tsg?.id) {
      fetchDeploymentProfile(tsg?.id || globalTsgId, supportAccountId, instances)
      setProfileLoading(true)
      setDisable(false)
      //setAccordionOpen(false)
      //updateTitle('Deployment Profile(s): 0 Selected')
    }
    else {
      setAvailableProfiles([])
      setNotAvailableProfiles([])
      setDisable(true)
      setAccordionOpen(false)
      updateTitle('Deployment Profile(s): 0 Selected')
    }
  }, [supportAccountId, tsg, globalTsgId])

  const isProfileAvaiable = useMemo(() => {
    return availableProfiles.length > 0 || notAvailableProfiles.length > 0
  }, [availableProfiles, notAvailableProfiles])

  const getTitle = (profiles: any[]) => {
    if (!profiles?.length) {
      <div>Deployment Profile(s): 0 Selected</div>
    }
    return (
      <div className='tw-h-full tw-truncate cm-py-2'>
        <div>Deployment Profile(s): {`${profiles.length}`} Selected</div>
        <div className='cm-pt-2'>
          {profiles?.map((each, i) => (<Body key={i}><Bold>{each.profileName} :</Bold> {each.subscriptions.map((s: any) => getAppName(s.app_id)).join(' , ')}</Body>))}
        </div>
      </div>)
  }
  const handleSelect = (event: { currentTarget: { name: any; checked: boolean; }; }) => {
    const value = event.currentTarget.name
    const isChecked = event.currentTarget.checked
    let finalList: string[] = []
    if (isChecked) {
      //Add checked item into checkList
      finalList = [...checkedList, value]
    }
    else {
      //Remove unchecked item from checkList
      finalList = checkedList.filter((item) => item !== value)
    }
    // console.log('finalList',))
    setCheckedList(finalList)
    updateTitle(getTitle(availableProfiles.filter((p) => finalList.includes(p.dAuthCode))))
    setValue('deployment_profiles', availableProfiles.filter((p) => finalList.includes(p.dAuthCode)).map((s) => _.omit(s, ['isAssociated', 'isProfileCompatible'])))
  }
  const renderAvailableProfile = () => {
    if (!availableProfiles?.length) {
      return (<></>)
    }
    return (<div className='cm-mt-4'>
      AVAILABLE
      <div className='cm-mt-4 tw-overflow-y-scroll' style={{ maxHeight: 190 }}>{
        availableProfiles?.map((item, index) => {
          const subscriptions = item.subscriptions.map((s) => getAppName(s.app_id)).join(' , ')
          return (
            <div key={index} className='cm-flex cm-flex-row cm-pt-2'>
              <div>
                <Checkbox
                  key={item.dAuthCode}
                  disabled={false}
                  name={item.dAuthCode}
                  label={`${item.profileName}: ${subscriptions}`}
                  showLabel={false}
                  defaultValue={item.isAssociated as any}
                  register={{
                    required: false,
                    onChange: handleSelect
                  }}>
                </Checkbox>
              </div>
              <div className='cm-pt-1'>
                <span><b>{`${item.profileName || item.dAuthCode}: `}</b>{`${subscriptions}`}</span><br />
                <span>{`Auth Code: ${item.dAuthCode}`}</span>
              </div>
            </div>)
        })
      }
      </div>
    </div>)
  }
  const renderUnAvailableProfile = () => {
    if (!notAvailableProfiles?.length) {
      return (<></>)
    }
    return (<div className='cm-mt-4'>
      UNAVAILABLE
      <Banner
        type='inline'
        showIcon
        appearance={'warning'}
      >
        The following profile(s) are not compatible with your selected recipient tenant.
      </Banner>

      <div className='cm-mt-4 tw-overflow-y-scroll' style={{ maxHeight: 190 }}>{
        notAvailableProfiles?.map((item, index) => {
          const subscriptions = item.subscriptions.map((s) => getAppName(s.app_id)).join(',')
          return (
            <div key={index} className='cm-flex cm-flex-row cm-pt-2'>
              <div>
                <Checkbox
                  key={item.dAuthCode}
                  disabled={true}
                  name={item.dAuthCode}
                  label={`${item.profileName}: ${subscriptions} :`}
                  defaultValue={item.isAssociated as any}
                  showLabel={false}>
                </Checkbox>
              </div>
              <div className='cm-pt-1'>
                <span><b>{`${item.profileName || item.dAuthCode}: `}</b>{`${subscriptions}`} <Tag appearance='orange'>Requires Cortex Data Lake</Tag></span><br />
                <span>{`Auth Code: ${item.dAuthCode}`}</span>
              </div>
            </div>)
        })
      }
      </div>
    </div>)
  }
  return (
    <div className='cm-min-h-full'>
      {profileLoading && <ScreenLoader />}
      <UAccordionHeader title={title || ''} subtitle={subtitle || ''} />
      {!isProfileAvaiable ? <div className='cm-mt-4'>
        <Banner
          type='inline'
          showIcon
          appearance={'warning'}
        >
          The selected Customer Support Account does not have any available Deployment Profiles.
        </Banner>
      </div> : ''}
      {renderAvailableProfile()}
      {renderUnAvailableProfile()}
      {/* {
        isProfileAvaiable ? <div className='cm-mt-4'>
          AVAILABLE
          {
            availableProfiles?.map((item, index) => {
              const subscriptions = item.subscriptions.map((s) => getAppName(s.app_id)).join(' , ')
              return (
                <div key={index} className='cm-flex cm-flex-row cm-pt-2'>
                  <div>
                    <Checkbox
                      key={item.dAuthCode}
                      disabled={false}
                      name={item.dAuthCode}
                      label={`${item.profileName}: ${subscriptions}`}
                      showLabel={false}
                      register={{
                        required: false,
                        onChange: handleSelect
                      }}>
                    </Checkbox>
                  </div>
                  <div className='cm-pt-1'>
                    <span><b>{`${item.profileName}: `}</b>{`${subscriptions}`}</span><br />
                    <span>{`Auth Code: ${item.dAuthCode}`}</span>
                  </div>
                </div>)
            })
          }
        </div>
          : ''}
      {
        isProfileAvaiable ? <div className='cm-mt-4'>
          UNAVAILABLE
          <Banner
            type='inline'
            showIcon
            appearance={'warning'}
          >
            The following profile(s) are not compatible with your selected recipient tenant.
          </Banner>
          {
            notAvailableProfiles?.map((item, index) => {
              const subscriptions = item.subscriptions.map((s) => getAppName(s.app_id)).join(',')
              return (
                <div key={index} className='cm-flex cm-flex-row cm-pt-2'>
                  <div>
                    <Checkbox
                      key={item.dAuthCode}
                      disabled={true}
                      name={item.dAuthCode}
                      label={`${item.profileName}: ${subscriptions} :`}
                      showLabel={false}>
                    </Checkbox>
                  </div>
                  <div className='cm-pt-1'>
                    <span><b>{`${item.profileName}: `}</b>{`${subscriptions}`} <Tag appearance='orange'>Requires Cortex Data Lake</Tag></span><br />
                    <span>{`Auth Code: ${item.dAuthCode}`}</span>
                  </div>
                </div>)
            })
          }
        </div> : ''
      } */}
    </div>
  )
}

export default UDeploymentProfiles

